module.exports = __webpack_public_path__ + "img/about.e211e79c.png";